import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { fadeIn } from 'styles/theme';

interface IBackdropProps {
  children: ReactNode;
}

export const Backdrop = ({ children }: IBackdropProps) => (
  <Backdrop.Backdrop>{children}</Backdrop.Backdrop>
);

Backdrop.Backdrop = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  padding: 20px;
  position: fixed;
  top: 0;
  width: 100%;
  ${fadeIn};
  ${({ theme }) => css`
    background-color: transparent;
    z-index: ${theme.zIndex.backdrop};
  `}
`;
